// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HkPj","col":"styles_col__3iaa6"};